const NoSearchResults = () => (
  <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.1805 36.8001C30.5311 36.8001 37.3006 30.0306 37.3006 21.6801C37.3006 13.3295 30.5311 6.56006 22.1805 6.56006C13.83 6.56006 7.06055 13.3295 7.06055 21.6801C7.06055 30.0306 13.83 36.8001 22.1805 36.8001Z"
      fill="white"
      stroke="#AAABAB"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.9405 45.4395L32.9805 32.4795"
      stroke="#AAABAB"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3477 27.0527L27.5537 16.8467"
      stroke="#AAABAB"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M27.5537 27.0527L17.3477 16.8467"
      stroke="#AAABAB"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export default NoSearchResults;
